import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Percent } from "lucide-react";

export const DiscountDialog = ({
  open, onClose,
  selectedCartItem, cart,
  discountInput, setDiscountInput,
  updateCartItemDiscount, focusSearchInput,
}) => {
  const item = cart.find(i => i.product_id === selectedCartItem);
  const discountVal = parseFloat(discountInput) || 0;

  const applyDiscount = () => {
    if (selectedCartItem && discountInput) {
      updateCartItemDiscount(selectedCartItem, parseFloat(discountInput));
      onClose();
      focusSearchInput();
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => {
      if (!o) { onClose(); focusSearchInput(); }
    }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Percent className="h-5 w-5 text-amber-600" /> Apply Discount
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          {item && (
            <div className="bg-slate-50 p-3 rounded-lg">
              <div className="font-semibold text-lg">{item.name}</div>
              <div className="text-sm text-slate-600">
                Max discount: {item.max_discount_percent || 0}%
              </div>
            </div>
          )}
          <div className="space-y-2">
            <Label htmlFor="discount-input" className="text-base">Discount Percentage</Label>
            <Input
              id="discount-input" type="number"
              value={discountInput}
              onChange={(e) => setDiscountInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') applyDiscount();
                else if (e.key === 'Escape') onClose();
              }}
              placeholder="e.g. 10" min="0"
              max={item?.max_discount_percent || 100}
              className="text-2xl h-14 text-center font-bold" autoFocus
            />
            {discountVal > 0 && item && (
              <div className="text-center text-lg font-semibold text-green-600 mt-2">
                {(() => {
                  const discountAmount = item.unit_price * item.quantity * discountVal / 100;
                  const newTotal = item.unit_price * item.quantity - discountAmount;
                  return `Discount: -R ${discountAmount.toFixed(2)} → New Total: R ${newTotal.toFixed(2)}`;
                })()}
              </div>
            )}
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => { onClose(); focusSearchInput(); }}>Cancel</Button>
          <Button onClick={applyDiscount} disabled={!discountInput || discountVal < 0}
            className="bg-amber-600 hover:bg-amber-700">
            Apply Discount
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
